<template>
    <div>
     <h6>Log my activities</h6>
    </div>
</template>

<script>
export default {
  name: 'ActivityLogger',

};
</script>

<style lang="scss" scoped>

</style>
